import { render } from "./Side.vue?vue&type=template&id=ff107e44"
const script = {}

import "./Side.vue?vue&type=style&index=0&id=ff107e44&lang=less&scope=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__